import { BooleanParam, JsonParam, StringParam } from 'use-query-params';
import { encodeQueryParamsUsingSchema } from 'utils/useEncodedFilters/helpers';

export const getPendingSlidesLocation = ({ labId, studyId }: { labId: string; studyId?: string }) => ({
  pathname: '/procedures',
  search: `?${encodeQueryParamsUsingSchema(
    {
      labId,
      ...(studyId ? { filters: { studyId } } : {}),
      pendingSlidesMode: true,
      slidesMode: true,
    },
    {
      filters: JsonParam,
      labId: StringParam,
      pendingSlidesMode: BooleanParam,
      slidesMode: BooleanParam,
    }
  )}`,
});
